import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { SynchronizationService } from '../../services/synchronization.service';

import { ConfigLoaderService } from '../../config/configloader.service';
import { OAuth2Service } from '../../services/o-auth2.service';
import { SettingsService } from '../../services/settings.service';
import { Onlineuser } from '../../models/onlineuser';
import { OnlineuserService } from '../../services/onlineuser.service';
import { SettingsEventType } from '../../models/enums/settingsEventType';
import { MatDialog } from '@angular/material/dialog';
import { UserprofiledialogComponent } from '../dialogs/userprofildialog/userprofiledialog.component';

import { EventUserLoggedOutPers } from '../../models/syncEvents/persistenceEvents/eventUserLoggedOut';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-online-state',
  templateUrl: './online-state.component.html',
  styleUrls: ['./online-state.component.scss']
  })
export class OnlineStateComponent implements OnInit, OnDestroy {

  private projectBaseURL: string;
  public onlineUsers: Onlineuser[] = [];
  public onlineUsersProject: Onlineuser[];
  public loginText: string;
  public me: Onlineuser = new Onlineuser('', '', '', '');

  constructor(private synchronizationService: SynchronizationService,
    private configService: ConfigLoaderService,
    private oAuth2Service: OAuth2Service,
    private onlineUserService: OnlineuserService,
    private settings: SettingsService,
    protected translateService: TranslateService,
    private dialog: MatDialog) {

    this.projectBaseURL = `${this.configService.settings.pyWallServer.url}`;
  }
  @HostListener('window:beforeunload')
  ngOnDestroy() {
    this.synchronizationService.sendPersistenceEventNew(new EventUserLoggedOutPers(this.onlineUserService.getAvatarUrl()));
    this.logoutPySyncServer();
  }
  ngOnInit(): void {
    this.settings.getUpdateObservable().subscribe(settingsEventType => {
      if (settingsEventType === SettingsEventType.PROJECT_CHANGED) {
        this.updateMe();
      }
    });
    if (this.oAuth2Service.isLoggedIn()) {
      this.synchronizationService.subscribeEvent<any>('onlineUser')
        .subscribe(onlineUser => {
          this.allOnlineUser(onlineUser);
          this.onlineUsersProject = this.onlineUsers.filter(user => user.location === this.onlineUserService.getLocation());
        });
      this.onlineUserService.getCurrentUserInformation().subscribe(me => {
        this.me = me;
        this.me.location = this.settings.getProjectName();
        this.loginPySyncServer();
      });
    }
    else {
      this.onlineUserService.setNotLoggedInUser();
    }
    this.translateService.get('components.userProfile.login').subscribe(result => {
      this.loginText = result;
    });
  }
  updateMe(): void {
    if (this.oAuth2Service.isLoggedIn()) {
      this.me.location = this.settings.getProjectName();
      this.onlineUserService.setLocation(this.me.location);
      this.synchronizationService.sendEvent('updateLocation', this.onlineUserService.getMe());
      this.onlineUsersProject = this.onlineUsers.filter(user => user.location === this.onlineUserService.getLocation());
    }
  }
  allOnlineUser(onlineUser: Onlineuser[]): void {
    this.onlineUsers = onlineUser;
  }
  logout() {
    this.synchronizationService.sendPersistenceEventNew(new EventUserLoggedOutPers(this.onlineUserService.getAvatarUrl()));
    this.logoutPySyncServer();
    this.oAuth2Service.Logout();
  }
  logoutPySyncServer() {
    this.synchronizationService.sendEvent('loggedOut', this.onlineUserService.getMe());
  }
  loginPySyncServer() {
    this.synchronizationService.sendEvent('loggedIn', this.onlineUserService.getMe());
  }
  showUserProfil(user, logoutFunc) {
    const dialogRef = this.dialog.open(UserprofiledialogComponent, {
      data: { user: user, logout: logoutFunc },
      backdropClass: 'backdropBackground',
      autoFocus: false,
      panelClass: 'custom-user-profile-dialog'
    });
    dialogRef.afterClosed().subscribe(_ => {
    });
  }
  isLoggedIn(): boolean {
    return this.oAuth2Service.isLoggedIn();
  }
}
